// extracted by mini-css-extract-plugin
export var langSwitcher = "LangSwitcher-module--langSwitcher--4d58c";
export var langSwitcher__button = "LangSwitcher-module--langSwitcher__button--5b990";
export var langSwitcher__buttonOpen = "LangSwitcher-module--langSwitcher__buttonOpen--8b3e8";
export var langSwitcher__flag = "LangSwitcher-module--langSwitcher__flag--c5847";
export var langSwitcher__icon = "LangSwitcher-module--langSwitcher__icon--078ce";
export var langSwitcher__iconOpen = "LangSwitcher-module--langSwitcher__iconOpen--5f9fd";
export var langSwitcher__item = "LangSwitcher-module--langSwitcher__item--8f5af";
export var langSwitcher__menu = "LangSwitcher-module--langSwitcher__menu--ba2be";